<div class="sheet-handle"></div>

<div class="sheet-header">
  <div class="sheet-header-text">
    <h2 class="sheet-title">{{ title }}</h2>
    <p class="sheet-subtitle">{{ users.length }} participantes</p>
  </div>
  <button class="sheet-close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

@if (groups.length > 0) {
  <div class="sheet-filters">
    <button
      type="button"
      class="filter-chip"
      [class.active]="groupSelected === 'general'"
      (click)="selectGroup('general')"
    >
      🌍 General
    </button>
    @for (group of groups; track group._id) {
      <button
        type="button"
        class="filter-chip"
        [class.active]="groupSelected === group._id"
        (click)="selectGroup(group._id)"
      >
        {{ group.name }}
      </button>
    }
  </div>
}

<div class="sheet-body">
  <app-participants-list
    [users]="users"
    [positionByUserId]="positionByUserId"
    (userSelected)="selectUser($event)"
  ></app-participants-list>
</div>
